import {noop} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {FrontClickEvent} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {InfoBubblePillVariantsEnum} from '../../../../../libs/shared/ui/src/components/tip/infoBubblePill';
import heroImage from '../../../../assets/images/aiAnswersShowcaseAutomationEducationTip.svg';
import {EducationTip} from '../../../educationTips/educationTip';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

/*
 * Styles.
 */

const StyledImg = styled.img`
  display: block;
  width: 380px;
  height: 142px;
`;

/*
 * Component.
 */

export const AiAnswersShowcaseAutomationEducationTip: FC<SandboxEducationTipProps> = (props) => {
  const {trackDataEvent} = useDataEventTracking();

  const onNextClick = (event: FrontClickEvent) => {
    trackDataEvent(
      DataEventActionsEnum.CLICK,
      OnboardingDataEventObject.DEMO_AI_ANSWERS_SHOWCASE_AUTOMATION,
      {},
    );
    props.onNextClick(event);
  };

  return (
    <EducationTip
      hero={<StyledImg src={heroImage} alt="Front automation illustration" />}
      anchor={props.anchor}
      position="left-start"
      isInteractive
      isVisible={props.isVisible}
      // Make it look nicer with the corners of the chat preview article.
      overlayBorderRadius={20}
      // Don't do any scrolling, since the chat preview takes care of that.
      scrollsIntoView={false}
      onRequestClose={noop}
      pillType={InfoBubblePillVariantsEnum.EDUCATION}
      title={
        <Trans id="infobubble-onboarding-ai-answers-showcase-automation-title">
          Personalized support in real time
        </Trans>
      }
      stepCounter={generateStepText(3, 4)}
      onPrimaryClick={onNextClick}
      primaryActionLabel={
        <Trans id="infobubble-onboarding-ai-answers-showcase-automation-primary">Next</Trans>
      }
      dataObjectName={OnboardingDataEventObject.DEMO_AI_ANSWERS_SHOWCASE_AUTOMATION}
    >
      <Trans id="infobubble-onboarding-ai-answers-showcase-automation-description">
        Chatbots can branch or respond based on visitor data to make resolutions easier than ever. Here, it
        will route to an agent because it’s within business hours.
      </Trans>
    </EducationTip>
  );
};
